<template>
    <div>
        <FileBulkUploadDialog />
        <FileImportDialog :alvqaContext="alvqa + '-list'">
            <template v-slot:importOptions>
                <v-row v-if="isMappingImport">
                    <v-col>
                        <BaseEditPageDropdown
                            :context="context"
                            field="ImportSelectedMapping"
                            :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                            :items="mappingAbbreviations"
                            :clearable="false"
                            :withMargin="false"
                            :alvqa="alvqa + '-mapping-import-dropdown-select-abbreviation'"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="isMappingImport" justify="center">
                    <v-col>
                        <BaseEditPageTextField
                        :context="context"
                        field="ImportTags"
                        :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
                        :withMargin="false"
                        :alvqa="alvqa + '-list-import-dialog-textfield-tags'"
                        />
                    </v-col>
                </v-row>
            </template>
        </FileImportDialog>
        <SelectionRequiredDialog /> 
		<DeletionDialog context="SelectedLabelTracks" />	
        <ManageTagsDialog 
			context="Tracks" 
			dir='label/tracks'
			idAttributeName='alvIds'
		/>
        <TracksSearchContractsDialog />
        <BaseListPage
            headline="lang_LABEL_TRACKS"
            :context="context"
            :alvqa="alvqa"
            :stickyHeader="true"
        >
		<!-- FILTERS -->
		<!-- 
			Search-Textfield is already a part of the BaseListPage, 
			the base component will automatically add this search-field.
			Every other filter can be added in the filter slot.
		-->
			<template v-slot:filter>
                <v-col cols="3">
                    <DropdownFilter 
                    :context="context + 'LabelsFilter'"
                    label="lang_LABEL_RELEASES_FILTER_CAPTION_CATALOGS"
                    :items="labelsItems"
                    :alvqa="alvqa + '-list-dropdown-labels'"
                    />
                </v-col>
				<v-col cols="3">
					<DropdownFilter 
						:context="context + 'QualityFilter'"
						label="lang_GENERIC_CAPTION_QUALITY"
						:items="qualityItems"
						:alvqa="alvqa + '-list-dropdown-quality'"
					/>
				</v-col>
			</template>
<!-- DATA TABLE -->	
            <template v-slot:dataTable>
                <BaseDataTableList 
                    :headers="headers"
                    :context="context"   
					:alvqa="alvqa"
                    :hasServerSideSorting='true'
                    :stickyTopSlot="true"
                >
                <!-- TOPSLOT: actions, imports etc. -->
                    <template v-slot:topSlot> <TracksTopSlot /> </template> 
                <!-- DATA TABLE CONTENT: columns -->
					<template v-slot:body="{ item }">
                        <ExpandIcon 
                            :isExpanded="item.isExpanded" 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
                        />
                        <td class="no_ellipsis text-center">
                            <BaseIcon 
                                v-if="item.item.audioTrack || (item.item.audioTrack && item.item.cover)"
                                @click.stop="play(item.item)"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-audio'"
                                :icon="item.item.isPlaying ? 'fa-stop-circle' : 'fa-play-circle'"   
                                :tooltipText="item.item.isPlaying ? 'lang_GENERAL_CAPTION_STOP' : 'lang_GENERAL_CAPTION_PLAY'"    
                            />
                            <!-- <div v-else-if="!item.item.audioTrack && (item.item.cover !== undefined && item.item.cover !== null)">
                                <v-img 
                                    :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-play'"
                                    :src="item.item.cover"
                                    width="40px"
                                ></v-img>

                            </div>
                            <div v-else>
                                <BaseIcon
                                @click.stop="uploadAudioFile()"
                                color="iconDelete"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-upload-audio'"
                                icon='backup'   
                                :tooltipText="'lang_GENERAL_CAPTION_NO_DATA_AVAILABLE'"    
                            />
                            </div> -->
                            <div v-else>
                                <v-img 
                                    :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image-default'"
                                    :src="require('@/assets/default_picture/default.jpg')"
                                    width="40px"
                                ></v-img>
                            </div>
                        </td>
						<td class="ellipsis">
                            <BaseTooltip 
                                :simpleText="getTitle(item.item)" 
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-track-title'"
                            />							
						</td>
                        <td class="ellipsis">
                            <BaseTooltip 
                                :simpleText="item.item.displayArtist" 
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-display-artist'"
                            />
                        </td>
                        <td
                            class="text-right"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-duration'"
                        >
                            {{ $alvPlugin.transformSecondsToDuration(item.item.duration) }}
                        </td>
                        <td class="no_ellipsis text-right"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-isrc'"
                        >
                            {{ item.item.isrc }}
                        </td>
					</template>
                <!-- EXPAND: Read Only View -->
                    <template v-slot:expandSlot="{ id }"><TrackReadOnly :itemId='id' /></template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseListPage from '@/components/_base/BaseListPage'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import DropdownFilter from '@/components/_filters/DropdownFilter'

import TracksTopSlot from './TracksTopSlot'
import TrackReadOnly from './_readonly/TrackReadOnly'

import FileBulkUploadDialog from '@/components/_dialogs/FileBulkUploadDialog'
import FileImportDialog from '@/components/_dialogs/FileImportDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'
import TracksSearchContractsDialog from './_dialogs/TracksSearchContractsDialog'

export default {
    name: 'TracksList',
    components: { 
        BaseDataTableList,
		BaseListPage,
        BaseIcon,
        BaseTooltip,
        ExpandIcon,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        DropdownFilter,

        TracksTopSlot,
        TrackReadOnly,

        FileBulkUploadDialog,
        FileImportDialog,
        DeletionDialog,
        SelectionRequiredDialog,
        ManageTagsDialog,
        TracksSearchContractsDialog
    },
    data() {
        return {
            context: "Tracks",
            alvqa: "label-tracks"
        }
    },
    computed: {
        ...mapGetters(['getTracksSearch']),

		/** Returns an Array with header-objects with props.
        *  @return {[{text: String, align: string, sortable: string, value: string}]} props of the header */        
        headers() {
            return [
				{
					text: '', 
					value: 'data-table-select', 
					align: 'center',
                    width: "60px",
                    sortable: false,
                    class: 'text-no-wrap'
                },
				{
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
                    width: "48px",
                    sortable: false,
                    class: 'text-no-wrap'
				},
                {
                    text: '', 
                    value: 'audioTrack',
                    align: 'center', 
                    width: "65px", 
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_TRACKS_CAPTION_TRACK_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_TRACKS_CAPTION_DISPLAY_ARTIST'), 
                    value: 'displayArtist',
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_LABEL_TRACKS_CAPTION_DURATION'), 
                    value: 'duration',
                    align: 'right', 
                    sortable: false,
                    width: '90px',
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_ISRC'), 
                    value: 'isrc',
                    align: 'end', 
                    sortable: true,
                    width: "160px",
                    class: 'text-no-wrap'
                },
                {
					text: '', 
					value: 'ghost',
					sortable: false,
                    class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
				}
            ]
        },
        qualityItems() {
            return[
                {
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NO_CONTRACT'), 
					value: 'noContract',
					alvqa: this.alvqa + '-list-dropdown-quality-no-contracts-connected'
				},
                {
					text: this.$t('lang_LABEL_TRACKS_DROPDOWN_QA_FILTER_NO_ISRC'), 
					value: 'noIsrc',
					alvqa: this.alvqa + '-list-dropdown-quality-no-isrc'
				},
                {
					text: this.$t('lang_LABEL_TRACKS_DROPDOWN_QA_FILTER_NO_ARTIST_AZ'), 
					value: 'noArtistAz',
					alvqa: this.alvqa + '-list-dropdown-quality-no-artist-az'
				},
            ]
        },
        listItems() { return this.$store.getters['getTracks'] },	
        globalAudio: {
            get() { return this.$store.getters['getAudio'] },
            set(item) { this.$store.commit('setAudio', item) }
        },
        labelsItems() { 
            let labels = []
            let labelsDropdown = []
            let selectedLabelCompany = this.$store.getters.getSelectedLabelCompanyId
            
            // TODO: Breadcrumb issue (sometimes a object is set and sometimes only the id of the company) also causes a problem here,
            // need to change that as soon as breadcrumb issue is fixed!
            if(selectedLabelCompany && typeof selectedLabelCompany === 'object' && selectedLabelCompany.constructor === Object) {
            selectedLabelCompany = selectedLabelCompany.id
            }

            this.$store.getters.getLabelCompanies.forEach((labelCompany) => {
                if(labelCompany.labels != null) {
                if (labelCompany.id == selectedLabelCompany)
                    labels = labels.concat(labelCompany.labels)
                }
            })
            labels.forEach((label) => {
                labelsDropdown.push({
                    "value": parseInt(label.id),
                    "text": label.name_alv + ' (' + label.alvId + ')',
                    "alvqa": this.alvqa + '-list-dropdown-label-' + parseInt(label.id)
                })
            })
            if(labelsDropdown === undefined || labelsDropdown.length === 0 || labelsDropdown.error === 1) 
            labelsDropdown = []
                return labelsDropdown.sort(this.sortLabelItemsList)
        },
        isMappingImport() {
            return this.$store.getters.getSelectedFileImport === 'mappingImport';
        },
        mappingAbbreviations() {
            let mappingsList = this.$store.getters.getMappings
            let retArr = []

            mappingsList.forEach((v) => {
				if (v.direction !== 'import') return;
                retArr.push({
                    value: v.alvId,
                    text: v.abbreviation,
                    alvqa: this.alvqa + `-import-mapping-${v.alvId}`,
                    disabled: v.columnMappingsCount === 0, // Disable if no column mappings exist for this mapping
                })
            })

            // Sort by ALVID descending (highest first), with disabled options at the end
            retArr.sort((a, b) => {
                if (a.disabled === true) return 1; // Put disabled at the end
                if (b.disabled === true) return -1;
                const alvIdA = parseInt(a.value.replace(/\D/g, '')) || 0
                const alvIdB = parseInt(b.value.replace(/\D/g, '')) || 0
                return alvIdB - alvIdA
            })
            // Auto-select first option and show warning if none (no watchers, contained here)
            if (this.isMappingImport && retArr.length > 0) {
                const selected = this.$store.getters.getTracksDetailsImportSelectedMapping
                const found = retArr.find(o => o.value === selected)
                if (selected === null || selected === undefined || !found) {
                    this.$store.commit('setTracksDetailsImportSelectedMapping', retArr[0].value)
                }
            }
            if (this.isMappingImport && retArr.length === 0 && this.$store.getters.getIsLoading === false) {
                const warn = this.$t('lang_GENERIC_MESSAGE_WARNING_NO_MAPPINGS_AVAILABLE_FOR_DOMAIN')
                this.$store.commit('setImportDialogText', `<span class=\"error--text\">${warn}</span>`)
            }

            return retArr
        }
    },
    methods: {
        /*
            Function triggered on clicking 'play' icon in track list
            item.isPlaying is used for icon and tooltip text change. Added after fetching data from backend
            this.globalAudio is used for creating Audioi() object and playing/pausing audio. From $store
        */
        play (item) {  
            // if audio is playing but not clicked one
            // stop playing and set isPlaying property for found track to false
            if(this.globalAudio != null  && !item.isPlaying) {
                this.globalAudio.pause();
                this.globalAudio = null;
                let index = this.listItems.findIndex(track =>
                    track.isPlaying === true
                );
                this.listItems[index].isPlaying = false;
            }

            // if audio is not playing (null)
            // create, add event, change isPlaying to true and play audio
            // else
            // pause current track, set global property to null and change isPlaying
            if(this.globalAudio == null) { 
                this.globalAudio = new Audio(item.audioTrack);
                this.globalAudio.addEventListener('ended', this.endedAudioEvent.bind(event, item));
                item.isPlaying = true
                this.globalAudio.play()
            } else {
                this.globalAudio.pause()
                item.isPlaying = false
                this.globalAudio = null
            }
        },
        uploadAudioFile(){
            return
        },
        endedAudioEvent(item) {
            item.isPlaying = false
            this.globalAudio = null
        },
        getTitle(item) {
            let displayTitle = item.title

            if(item.version !== null) displayTitle += ' (' + item.version + ')'

            return displayTitle
        },
         sortLabelItemsList( a, b ) {
            if ( a.text < b.text ){
                return -1;
            }
            if ( a.text > b.text ){
                return 1;
            }
            return 0;
        },
        getMappings() {
            this.$store.commit('setSelectedMappingsDomainsFilter', 'label_tracks')
            this.$store.dispatch('fetchMappingsByDomain')
        }
    },
    beforeRouteLeave (to, from, next) {
        let index = this.listItems.findIndex(track =>
            track.isPlaying === true
        )
        
        if(index !== -1) {
            this.listItems[index].isPlaying = false
            this.globalAudio.pause()
            this.globalAudio = null
        }

        next()
    },
    created(){
        this.$store.commit('setSelectedTracksLabelsFilter',[])

        this.getMappings()
    }
}
</script>